// Position Statuses
export const TOTAL_POSITIONS = 'All Requisitions';
export const STATUS_IN_DRAFT = 'In Draft';
export const STATUS_REQUISITION_REVIEW = 'Requisition Review';
export const STATUS_PENDING_APPROVAL = 'Pending Approval';
export const STATUS_REQUISITION_APPROVED = 'Requisition Approved';
export const STATUS_DRAFT_CHANGE_REQUESTED = 'Change Requested';
export const MOVED_TO_DRAFT = 'Moved to Draft';
export const POSITION_CREATED = 'Position Created';

export const SEND_FOR_APPROVAL = 'Send For Approval';
export const MAP_REVIEW_POLICY = 'Map Review Policy';

//Action Flow
export const REVIEW_APPROVED = 'Review Approved';
export const REJECTED = 'Rejected';
export const POSITION_APPROVED = 'Position Approved';
